import axios from 'axios';
import { CheckIcon } from 'lucide-react';
import { BrowserRouter as Router } from 'react-router';
import { Toaster } from 'sonner';
import { AnalyticsProvider } from './contexts/analytics-context/analytics-provider';
import { DataProvider } from './contexts/data-context/data-provider';
import { ErrorBoundary } from './contexts/error-boundary/error-boundary';
import { FeatureFlagProvider } from './contexts/feature-flag-context/feature-flag';
import { SSEProvider } from './contexts/sse-context/sse-provider';
import { SwrProvider } from './contexts/swr-provider';
import { UserInfoProvider } from './contexts/user-context/user-info-provider';
import { UserProvider } from './contexts/user-context/user-provider';
import { AppRoutes } from './routes/app-routes';
import { tw } from './utils/tw';

export const App = () => {
  axios.defaults.timeout = 30000; // 30 seconds
  return (
    <Router>
      <ErrorBoundary>
        <SwrProvider>
          <FeatureFlagProvider>
            <AnalyticsProvider>
              <UserInfoProvider>
                <SSEProvider>
                  <UserProvider>
                    <DataProvider>
                      <AppRoutes />

                      {/* https://sonner.emilkowal.ski/toaster */}
                      <Toaster
                        icons={{
                          success: <CheckIcon className="size-5 rounded-full bg-success p-0.5 text-white" />,
                        }}
                        toastOptions={{
                          classNames: {
                            toast: tw`rounded-lg border-2 border-primary bg-accent`,
                            title: tw`text-black`,
                            error: tw`text-red-500`,
                            success: tw`text-success`,
                            actionButton: tw`rounded-full bg-muted text-foreground`,
                          },
                        }}
                      />
                    </DataProvider>
                  </UserProvider>
                </SSEProvider>
              </UserInfoProvider>
            </AnalyticsProvider>
          </FeatureFlagProvider>
        </SwrProvider>
      </ErrorBoundary>
    </Router>
  );
};
